import { render, staticRenderFns } from "./Endpoints.vue?vue&type=template&id=b1c1943c&scoped=true&"
import script from "./Endpoints.vue?vue&type=script&lang=ts&"
export * from "./Endpoints.vue?vue&type=script&lang=ts&"
import style0 from "./Endpoints.vue?vue&type=style&index=0&id=b1c1943c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c1943c",
  null
  
)

export default component.exports